import React, { useState } from 'react';
import { Popover } from '@round/ui-kit';
import styles from './CustomNames.module.css';
import Card from '../../../../../ui/Card/Card';
import CustomNameInput from '../CustomNameInput/CustomNameInput';
import { ClientMonitoredTiktokAudioRelationship } from '@round/api';

type CustomNamesProps = {
    clientMonitoredAudioRelationships?: ClientMonitoredTiktokAudioRelationship[];
};

const CustomNames = ({ clientMonitoredAudioRelationships = [] }: CustomNamesProps) => {
    const [nameRef, setNameRef] = useState<HTMLDivElement | null>(null);

    if (!clientMonitoredAudioRelationships?.length) {
        return null;
    }

    const [first, ...rest] = clientMonitoredAudioRelationships;
    const label = rest.length > 0 ? ` and ${rest.length} more` : '';
    return (
        <>
            <div ref={setNameRef} className={styles.customNameContainer}>
                <CustomNameInput readonly clientMonitoredAudioRelationship={first} />
                <span>{label}</span>
            </div>
            {clientMonitoredAudioRelationships.length > 1 && (
                <Popover anchorElement={nameRef} showOn="hover" options={{ placement: 'top-start' }}>
                    <Card className={styles.popover}>
                        {clientMonitoredAudioRelationships.map((item) => (
                            <CustomNameInput key={item.client_id} readonly clientMonitoredAudioRelationship={item} />
                        ))}
                    </Card>
                </Popover>
            )}
        </>
    );
};

export default CustomNames;
